<template>
  <div class="competence-wrapper mb-4">
    <div class="form-select-group">
      <label class="select-label">Competência</label>

      <div class="select-input-container">
        <vue-monthly-picker
          ref="monthlyPicker"
          class="custom-monthly-picker"
          :value="selectedDate"
          :monthLabels="monthLabels"
          dateFormat="MM/YYYY"
          :max="maxDate"
          @input="onDateChange"
        ></vue-monthly-picker>
      </div>
    </div>

    <div class="status-update-info">
      <img
        v-if="isLoading"
        class="update-icon img-refresh img-refresh--loading"
        src="@/assets/images/refresh.svg"
        alt="Carregando..."
      />

      <img
        v-else
        class="update-icon img-refresh"
        src="@/assets/images/refresh.svg"
        alt="Atualizar"
      />

      <p
        class="update-label mb-0"
        v-html="formattedUpdateText"
      ></p>
    </div>
  </div>
</template>

<script>
import VueMonthlyPicker from "vue-monthly-picker";

export default {
  name: "CompetenceFilter",

  components: {
    VueMonthlyPicker,
  },

  props: {
    value: {
      type: [Object, String, Date],
      default: "",
    },

    lastUpdateDate: {
      type: String,
      default: null,
    },

    maxDate: {
      type: [Object, String, Date],
      default: null,
    },

    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      monthLabels: [
        "JAN",
        "FEV",
        "MAR",
        "ABR",
        "MAI",
        "JUN",
        "JUL",
        "AGO",
        "SET",
        "OUT",
        "NOV",
        "DEZ",
      ],

      pickerObserver: null,
    };
  },

  computed: {
    selectedDate() {
      return this.value;
    },

    formattedUpdateText() {
      return this.onDataUpdate();
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.fixMonthlyPicker();
      this.observeMonthlyPicker();
    });
  },

  beforeDestroy() {
    if (this.pickerObserver) {
      this.pickerObserver.disconnect();
      this.pickerObserver = null;
    }
  },

  methods: {
    onDateChange(date) {
      this.$emit("input", date);
      this.$emit("change", date);

      this.$nextTick(() => {
        this.fixMonthlyPicker();
      });
    },

    onDataUpdate() {
      if (!this.lastUpdateDate) {
        return "<strong>Última atualização:</strong> não identificada.";
      }

      return `<strong>Última atualização em:</strong> ${this.lastUpdateDate}.`;
    },

    fixMonthlyPicker() {
      const picker = this.$refs.monthlyPicker;

      if (!picker || !picker.$el) {
        return;
      }

      const displayText = picker.$el.querySelector(
        ".month-year-display .display-text"
      );

      const input = picker.$el.querySelector(
        ".month-year-display.input"
      );

      if (displayText) {
        displayText.style.setProperty("width", "auto", "important");
        displayText.style.setProperty("min-width", "0", "important");
        displayText.style.setProperty("max-width", "none", "important");
        displayText.style.setProperty("flex", "0 0 auto", "important");
        displayText.style.setProperty("margin-left", "0", "important");
        displayText.style.setProperty("margin-right", "auto", "important");
        displayText.style.setProperty("text-align", "left", "important");
      }

      if (input) {
        input.style.setProperty(
          "justify-content",
          "flex-start",
          "important"
        );
      }
    },

    observeMonthlyPicker() {
      const picker = this.$refs.monthlyPicker;

      if (!picker || !picker.$el) {
        return;
      }

      this.pickerObserver = new MutationObserver(() => {
        this.fixMonthlyPicker();
      });

      this.pickerObserver.observe(picker.$el, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["style", "class"],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.competence-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .form-select-group {
    display: flex;
    flex-direction: column;

    .select-label {
      font-size: 16px;
      line-height: 24px;
      color: #212529;
      margin-bottom: 8px;
      font-weight: 400;
    }
  }

  .status-update-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    height: 29px;

    .img-refresh {
      height: 16px;
      width: 16px;

      &--loading {
        animation: spin 1s linear infinite;
      }
    }

    .update-label {
      font-family: "Trebuchet MS", sans-serif;
      font-size: 12px;
      line-height: 12px;
      color: #6c757d;
      font-weight: 400;

      ::v-deep strong {
        font-weight: 600;
        color: #6c757d;
      }
    }
  }

  .custom-monthly-picker {
    ::v-deep .month-year-display.input {
      width: 17rem !important;
      height: 3.8rem !important;
      background-color: #ffffff !important;
      border: 1px solid #ced4da !important;
      border-radius: 0.5rem !important;
      padding: 0 12px !important;
      box-shadow: none !important;

      display: flex !important;
      align-items: center !important;
      justify-content: flex-start !important;
    }
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
